import { render } from "./demo-login.vue?vue&type=template&id=ad6a312c&scoped=true&ts=true"
import script from "./demo-login.vue?vue&type=script&lang=ts"
export * from "./demo-login.vue?vue&type=script&lang=ts"

import "./demo-login.vue?vue&type=style&index=0&id=ad6a312c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6a312c"]])

export default __exports__